import { css } from '@emotion/react'
import { Flow, Heading, Theme, useTheme } from 'bold-ui'
import { ReactNode } from 'react'

interface MapaSidebarPanelProps {
  title: string
  children: ReactNode
  actions?: ReactNode
}

export function MapaSidebarPanel(props: Readonly<MapaSidebarPanelProps>) {
  const { title, children, actions } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Flow direction='vertical' gap={0} style={styles.panel}>
      <Flow direction='horizontal' justifyContent='space-between' style={styles.panelHeader}>
        <Heading level={2}>{title}</Heading>
        {actions}
      </Flow>
      <div css={styles.panelContent}>{children}</div>
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  panel: css`
    width: 18.5rem;
    border-right: 1px solid ${theme.pallete.divider};
    height: 100%;
    padding: 0.5rem 1rem 1rem 1rem;
    grid-template-rows: auto 1fr;
  `,
  panelHeader: css`
    padding-bottom: 0.5rem;
  `,
  panelContent: css`
    width: 100%;
    height: 100%;
  `,
})
